"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getRootElement = void 0;
const dynamicLoad_1 = require("../../dynamicLoad");
const getRootElement = () => {
    let rootElement = document.getElementById(dynamicLoad_1.DEFAULT_ROOT_ID);
    if (rootElement) {
        rootElement.innerHTML = '';
    }
    else {
        rootElement = document.createElement('div');
        rootElement.setAttribute('id', dynamicLoad_1.DEFAULT_ROOT_ID);
        rootElement.setAttribute('data-testid', dynamicLoad_1.DEFAULT_ROOT_ID);
        document.body.appendChild(rootElement);
    }
    return rootElement;
};
exports.getRootElement = getRootElement;
//# sourceMappingURL=renderUtils.js.map